<div class="vertical-menu-container">
    <div *ngIf="subjectTree?.length; else elseBlock">
        <swiper
            [coverflowEffect]="swiperOptions?.coverflowEffect"
            [slidesPerView]="swiperOptions?.slidesPerView"
            [navigation]="swiperOptions?.navigation"
            [autoplay]="swiperOptions?.autoplay"
            [spaceBetween]="swiperOptions?.spaceBetween"
            [direction]="'vertical'"
            [effect]="'coverflow'"
            [grabCursor]="true"
            [centeredSlides]="true"
            (slideChange)="onSlideChange($event)"
        >
            <ng-container *ngFor="let subject of subjectTree">
                <ng-template swiperSlide let-data>
                    <div
                        class="vertical-menu-slide gtm-student-cloud-subject"
                        [style.background]="data.isActive ? getSubjectColor(subject.id) : ''"
                        (click)="emitSelectedSubject(data, subject)"
                    >
                        {{ subject.title }}
                    </div>
                </ng-template>
            </ng-container>
        </swiper>
    </div>
    <ng-template #elseBlock> <span>No subjects.</span> </ng-template>
</div>
